// src/contexts/NotificationContext.tsx
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { getNotificationList } from '../services/notificationServices';
import { storage } from '../lib/storage';

type Notification = {
  id: string;
  type: string;
  message: string;
  createdAt: string;
  is_read: boolean;
  metadata?: Record<string, any>;
};

type AppContextType = {
  notifications: Notification[];
  setNotifications: (notifications: Notification[]) => void;
  markAsRead: (id: string) => void;
  ticketId: string;
  setTicketId: (id: string) => void;
  assignId: string;
  setAssignId: (id: string) => void;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export const ContextProvider = ({ children }: { children: ReactNode }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [ticketId, setTicketId] = useState<string>('');
  const [assignId, setAssignId] = useState<string>('');

  const markAsRead = (id: string) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id ? { ...notif, is_read: true } : notif
      )
    );
  };


  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = storage.getAccessToken()

        if(!token){
          return
        }
        const { rows } = await getNotificationList();
        setNotifications(rows || []);
      } catch (error) {
        console.error('Failed to fetch notifications:', error);
      }
    };

    fetchNotifications();
  }, []);



  return (
    <AppContext.Provider
      value={{
        notifications,
        setNotifications,
        markAsRead,
        ticketId,
        setTicketId,
        assignId,
        setAssignId,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useNotification must be used within ContextProvider');
  }
  return context;
};
